module.exports = __webpack_public_path__ + "img/sea-4.1ba0bf5c.jpg";